import type {
    HeaderValues,
    HttpHeaders,
    MutableHttpHeaders,
    ReadonlyHeaderValues, ReadonlyHttpHeaders
} from '../../types/web/http';
import { MediaType } from './media-type.ts';

function parseHeader(value: string): string[] {
    const list: string[] = [];
    {
        let start = 0;
        let end = 0;

        for (let i = 0; i < value.length; i++) {
            switch (value.charCodeAt(i)) {
                case 0x20: // space
                    if (start === end) {
                        start = end = i + 1;
                    }
                    break;
                case 0x2c: // comma
                    list.push(value.slice(start, end));
                    start = end = i + 1;
                    break;
                default:
                    end = end + 1;
                    break;
            }
        }
        list.push(value.slice(start, end));
    }

    return list;
}

function toList(values: number | string | (readonly string[]) | undefined): string[] {
    if (typeof values === 'string') {
        values = [values];
    }
    if (typeof values === 'number') {
        values = [String(values)];
    }
    const list: string[] = [];
    if (values) {
        for (const value of values) {
            if (value) {
                list.push(...parseHeader(value));
            }
        }
    }
    return list;
}

export abstract class AbstractHttpHeaders<Values extends HeaderValues | ReadonlyHeaderValues> {
    protected constructor() {
    }

    abstract get(name: string): Values

    toList(name: string): string[] {
        const values = this.get(name);
        return toList(values);
    }
}

export class MapHttpHeaders extends Map<string, (readonly string[])> implements MutableHttpHeaders {

    get(name: string) {
        return super.get(name.toLowerCase());
    }

    one(name: string): string | undefined {
        return this.get(name)?.[0];
    }

    list(name: string) {
        const values = super.get(name.toLowerCase());
        return toList(values);
    }

    set(name: string, value: number | string | (readonly string[]) | undefined): this {
        if (typeof value === 'number') {
            value = String(value);
        }
        if (typeof value === 'string') {
            value = [value];
        }
        if (value) {
            return super.set(name.toLowerCase(), value);
        }
        else {
            super.delete(name.toLowerCase());
            return this;
        }
    }

    add(name: string, value: string | (readonly string[])) {
        const prev = super.get(name.toLowerCase());
        if (typeof value === 'string') {
            value = [value];
        }
        if (prev) {
            value = prev.concat(value);
        }
        this.set(name, value);
        return this;
    }
}

export const EMPTY_HTTP_HEADERS: ReadonlyHttpHeaders = new MapHttpHeaders();


export function getContentType(headers: HttpHeaders): MediaType | undefined {
    const value = headers.one('content-type');
    return value ? MediaType.parseMediaType(value as string) : undefined;

}
